//Libraries
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Button, Rating as RatingCom } from "@mui/material";
import { useSelector } from "react-redux";

//Components
import {
  EmailCaptureModal,
  FeedbackModal,
  ThankYouModal,
} from "../../components/CustomModal/CustomModal";
import Klaviyo from "../../utils/klaviyo";

//Utils
import { db } from "../../utils/firebaseConfig";
import {
  addRating,
  findRating,
  addReview,
  addEmail,
  updateTimeStamp,
} from "../../utils/firestoreFunctions";

//Assets
import homepageLogo from "../../assets/homepage-logo.png";
import { useNavigate } from "react-router-dom";

export default function Rating() {
  const [value, setValue] = React.useState(0);
  const [openEmailCapture, setOpenEmailCapture] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [openThankYou, setOpenThankYou] = useState(false);
  const [rated, setRated] = useState("null");
  const [feedback, setFeedback] = useState("");
  const [email, setEmail] = useState("");
  const [shouldTriggerKlaviyo, setShouldTriggerKlaviyo] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(true); // Default checked
  const navigate = useNavigate();

  const userPhoneNumber = useSelector((state) => state.userData.phoneNumber);
  const currentUser = useSelector((state) => state.userData.currentUser);

  useEffect(() => {
    async function getData() {
      const result = await findRating(db, userPhoneNumber);
      if (result) {
        setRated(result);
        setValue(result.rating);
      }
    }
    getData();
  }, [userPhoneNumber]);

  useEffect(() => {
    if (rated !== "null" && rated === true) {
      navigate("/");
    }
  }, [rated, navigate]);

  const handleSubmitRating = () => {
    addRating(db, parseInt(userPhoneNumber), value);
    if (value > 3) {
      setOpenEmailCapture(true);
    } else if (value > 0 && value < 4) {
      handleOpenFeedback();
    } else {
      setRated(true);
    }
  };

  const handleCloseEmailCapture = () => {
    setOpenEmailCapture(false);
    updateTimeEmailCaptureShown(); 
    setRated(true); 
  };

  const updateTimeEmailCaptureShown = async () => {
    let key = `emailCaptureShown`;
    let obj = {};
    obj[key] = Math.floor(Date.now() / 1000);

    await updateTimeStamp(db, String(currentUser.phoneNumber), obj);
  };

  const handleSubmitEmail = async () => {
    if (email && email.includes("@") && marketingConsent) {
      await addEmail(db, parseInt(userPhoneNumber), email);

      let key = `emailSubmitted`;
      let obj = {};
      obj[key] = Math.floor(Date.now() / 1000);
      await updateTimeStamp(db, String(currentUser.phoneNumber), obj);

      // Only trigger Klaviyo if user consented to marketing emails
      setShouldTriggerKlaviyo(true);

      setOpenEmailCapture(false);
      setRated(true); 
    }
  };


  const handleOpenFeedback = () => {
    setOpenFeedback(true);
  };

  const handleCloseFeedback = () => {
    addReview(db, parseInt(userPhoneNumber), feedback);
    setOpenFeedback(false);
    handleOpenThankYou(); 
    navigate("/");
  };

  const handleOpenThankYou = () => {
    setOpenThankYou(true);
  };

  const handleCloseThankYou = () => {
    setOpenThankYou(false);
    navigate("/");
  };

  return (
    <Box textAlign="center" mt={2} color="white">
      <img src={homepageLogo} alt="crime cases" width="180px" />
      <Box mt={12} px={8}>
        <Typography variant="h2">
          {value >= 1
            ? "WIE HAT EUCH DAS SPIEL GEFALLEN?"
            : "WIE GUT HAT EUCH DAS SPIEL GEFALLEN?"}
        </Typography>
      </Box>
      <Box mt={12}>
        <RatingCom
          name="rating"
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          style={{ color: "#B683F6" }}
          size="large"
        />
      </Box>

      <EmailCaptureModal
        open={openEmailCapture}
        handleClose={handleCloseEmailCapture}
        email={email}
        setEmail={setEmail}
        handleSubmitEmail={handleSubmitEmail}
        marketingConsent={marketingConsent}
        setMarketingConsent={setMarketingConsent}
      />

      <FeedbackModal
        open={openFeedback}
        handleClose={handleCloseFeedback}
        feedback={feedback}
        setFeedback={setFeedback}
      />

      <ThankYouModal open={openThankYou} handleClose={handleCloseThankYou} />

      {/* Klaviyo component for email opt-in */}
      {shouldTriggerKlaviyo && email && <Klaviyo email={email} />}

      <Box mt={24} mb={8}>
        <Button
          variant="contained"
          onClick={handleSubmitRating}
          disabled={value >= 1 && userPhoneNumber !== "null" ? false : true}
        >
          WEITER
        </Button>
      </Box>
    </Box>
  );
}
